import { Component } from '@angular/core';
import { GenericCrudComponent } from '../../../../../shared/components/generic-crud/generic-crud.component';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../../models/Paginator';
import { Template } from '../../../../../models/Template';
import { GenericCRUD } from '../../../../../models/GenericCRUD/GenericCRUD';
import { Filter } from '../../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../../core/services/breadcrumb/breadcrumb.service';
import { TemplateService } from '../../../../../services/template.service'; 
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'app-template-configuration',
  standalone: true,
  imports: [GenericCrudComponent, RouterOutlet],  
  templateUrl: './template-home.component.html',
  styleUrl: './template-home.component.css'
})
export class TemplateHomeComponent {

  // Modal properties
  isFieldsModalOpen = false;
  selectedTemplate: Template | null = null;
  extractedFields: any[] = [];

  constructor(private breadcrumbService: BreadcrumbService, private templateService: TemplateService) {
    this.breadcrumbService.setBreadcrumb({
      display_name: 'Configuración de contratos',
      url: '/dashboard/configuracion/contratos',
      items: [
        { name: 'Configuración', url: '/dashboard/configuracion' }
      ]
    });
  }

  tableColumns: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'text-title', key: 'name', sort: true },
    { name: 'Fecha Creación', active: true, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy' }
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'file', type: 'document', label: 'Archivo de Plantilla', validations: 'required', colspan: 2, singleSelection: true }
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
  ];

  extractFieldsForm: GenericFormField[] = [
    { name: 'auto_extract', type: 'boolean-switch', label: 'Extracción Automática', validations: '' },
    { name: 'manual_fields', type: 'textarea', label: 'Campos Manuales (JSON)', validations: '' }
  ];

  form: GenericForm = {
    successTitle: 'Plantilla creada correctamente',
    errorTitle: 'Error al crear la plantilla',
    method: 'POST',
    fields: this.formFields,
    name: 'plantilla',
    createButtonTitle: 'Subir Plantilla',
    cols: 2,
    createApiSlug: '/template/store',
    originalUpdateApiSlug: '/template/update/{{id}}',
    updateApiSlug: '',
    originalFormTitle: 'Editar Plantilla',
    formTitle: 'Subir Nueva Plantilla',
    formButtonTitle: 'Subir',
    width: '3xl'
  };

  tableActions: GenericTableAction[] = [
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
      actionSlug: '/template/delete/{{id}}',
      confirmation: true,
      questionText: '¿Desea eliminar esta plantilla?',
      deleteRowOnResponse: true
    }
  ];


  table: GenericTable<Paginator<Template>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/template/index',
    paginate: true,
    name: 'Contratos',
    details: true,
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Buscar por nombre o descripción' },
  ];

  genericCRUD: GenericCRUD<Paginator<Template>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  };

  // Modal methods
  openFieldsModal(template: Template) {
    this.selectedTemplate = template;
    this.isFieldsModalOpen = true;
  }

  closeFieldsModal() {
    this.isFieldsModalOpen = false;
    this.selectedTemplate = null;
    this.extractedFields = [];
  }
}
